import React from "react";
import { cx } from "../../utils";
import { Heading, Text } from "../Typography/Typography";

export function SectionHeading({ id, eyebrow, title, number, className, compact = false }: {
  id: string; eyebrow: string; title: string; number: string; className?: string; compact?: boolean;
}) {
  return <div className={cx("flex min-h-[77px] items-end justify-between gap-3 border-b border-border-heading pb-[22px]", compact ? "mb-5" : "mb-6", className)}>
    <div><Text variant="eyebrow">{eyebrow}</Text>
      <Heading id={id}>{title}<span className="text-indicator">.</span></Heading>
    </div>
    <Text variant="sectionNumber">{number}</Text>
  </div>;
}
